/** @jsx jsx */
import { jsx } from '@emotion/core';
import React from 'react';
import Lottie from 'react-lottie';
import loadingAnimation from '../../../assets/animations/gray-load.json';
import { Breakpoints, ContainersWidth } from '../../../styles/Grid/GridSizes';
import { SafePureComponent } from '../../../utils/SafePureComponent';
import { Icon } from '../../ui/Icon';
import { Picture } from '../../ui/Picture';

import DotComponent from '../../ui/DotComponent';
import * as styles from './index.style';

import { Column, Container, Row } from '../../../styles/Grid';
import { CLOUDINARY_BASE_VALUES } from '../../../utils/constants';
// import Slider from './Slider';
import Spacer from '../../ui/Spacer';
import { get } from 'lodash';
import { Image, Link } from '@sitecore-jss/sitecore-jss-react';
const bigImageSizes = {
  [Breakpoints.sm]: {
    ...CLOUDINARY_BASE_VALUES,
    width: 240,
    height: 240,
    gravity: 'auto:subject',
  },
  [Breakpoints.md]: {
    ...CLOUDINARY_BASE_VALUES,

    width: 232,
    height: 232,
    gravity: 'auto:subject',
  },
  [Breakpoints.lg]: {
    ...CLOUDINARY_BASE_VALUES,
    width: 400,
    height: 400,
    gravity: 'auto:subject',
  },
  [Breakpoints.xl]: {
    ...CLOUDINARY_BASE_VALUES,
    width: 448,
    height: 448,
    gravity: 'auto:subject',
  },
};
const smallImageSizes = {
  [Breakpoints.sm]: {
    ...CLOUDINARY_BASE_VALUES,
    width: 152,
    height: 152,
    gravity: 'auto:subject',
  },
  [Breakpoints.md]: {
    ...CLOUDINARY_BASE_VALUES,
    width: 144,
    height: 144,
  },
  [Breakpoints.lg]: {
    ...CLOUDINARY_BASE_VALUES,
    width: 208,
    height: 208,
    gravity: 'auto:subject',
  },
  [Breakpoints.xl]: {
    ...CLOUDINARY_BASE_VALUES,
    width: 256,
    height: 256,
    gravity: 'auto:subject',
  },
};
export default class FeatureBulletLink extends SafePureComponent {
  renderImage = data => {
    const BigImage = get(data, 'BigImage', {});
    const SmallImage = get(data, 'SmallImage', {});
    return (
      <Column className="imgsec">
        <div className="img1">
          {BigImage && BigImage.value && (
            <Picture image={BigImage} imageSizes={bigImageSizes} instantLoad />
          )}
        </div>
        <div className="img2">
          {SmallImage && SmallImage.value && (
            <Picture
              image={SmallImage}
              imageSizes={smallImageSizes}
              instantLoad
            />
          )}
        </div>
      </Column>
    );
  };

  renderText = data => {
    const Title = get(data, 'Title.value', '');
    const BulletPoints = get(data, 'BulletPoints', []);
    const CTALink = get(data, 'CTALink', {});

    if (CTALink) {
      const CTAText = get(data, 'CTAText.value', '');
      CTALink.value.text = CTAText;
      CTALink.value.title = CTAText;
    }
    return (
      <Column className="contentsec">
        <div>
          <div>
            <h2>
              {Title}
              <DotComponent />
            </h2>
          </div>
          <div className="listsec">
            <ul>
              {BulletPoints.map((item, index) => {
                const iconSrc = get(item, 'fields.Icon', '');
                const bulletTitle = get(item, 'fields.Text.value', '');
                return (
                  <li key={item.id}>
                    <span className="icon_img">
                      {iconSrc && iconSrc.value && <Image field={iconSrc} />}
                    </span>
                    <span>{bulletTitle}</span>
                  </li>
                );
              })}
            </ul>
          </div>
          <div className="cta">
            {CTALink && <Link field={CTALink} editable={false} />}
            {/* <a href={data.CTA.link}>
              <span>{data.CTA.label}</span>
            </a> */}
          </div>
        </div>
      </Column>
    );
  };

  renderBlock = (ComponentStyle, data) => {
    if (ComponentStyle == 'ImageText') {
      return (
        <React.Fragment>
          {this.renderImage(data)}
          {this.renderText(data)}
        </React.Fragment>
      );
    } else {
      return (
        <React.Fragment>
          {this.renderText(data)}
          {this.renderImage(data)}
        </React.Fragment>
      );
    }
  };

  safeRender() {
    const { data } = this.props;

    const ComponentStyle = get(data, 'ComponentStyle.fields.Name.value', '');
    // const style = "TextImage";

    return (
      <Row className={`bulletimg style-` + ComponentStyle}>
        {this.renderBlock(ComponentStyle, data)}
      </Row>
    );
  }
}
